module.exports = "/fonts/feather.svg?90f969db293a9077b0555139e6c9b20e";